// used with string directly parsed to number and as a fallback separator
export const DEFAULT_DECIMAL_SEPARATOR = '.'
